import { render, staticRenderFns } from "./MiniOpenConfigurator.vue?vue&type=template&id=a635165c&scoped=true&"
import script from "./MiniOpenConfigurator.vue?vue&type=script&lang=js&"
export * from "./MiniOpenConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./MiniOpenConfigurator.vue?vue&type=style&index=0&id=a635165c&lang=scss&scoped=true&"
import style1 from "./MiniOpenConfigurator.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a635165c",
  null
  
)

export default component.exports